<template>
  <div class="q-pa-md">
    <q-list :dense="dense">
    <ZnakLayout v-for="(l,idx) in legenda" :key="idx">
      <template #znak>
        <span :style="'color:' + l.barva" :class="l.font">{{ l.znak }}</span>
      </template>
      <template #text>
        {{ l.odg }}
      </template>
    </ZnakLayout>
    </q-list>
  </div>
</template>

<script>
import "../styles/isla.sass";
import ZnakLayout from './ZnakLayout.vue'
import { znakStyle, fontAvatarClass } from '@/utils/font.js'

import { ref } from "vue";
import { mapGetters } from "vuex";

export default {
  name: "LegendTab",
  data() {
    return {
      dense: ref(true),
      details: ref({}),
      legenda: ref([])
    };
  },
  computed: {
    ...mapGetters(['getDetails']),

  },
  components: {
    ZnakLayout
  },

  watch: {
    getDetails(newVal) {
      this.details = newVal;
      this.showLegenda();
    },

  },
  methods: {
    znakStyle,
    fontAvatarClass,
    showLegenda() {
      if (!this.details.legenda) {
        this.legenda = [];
        return;
      }

      this.legenda = [...this.details.legenda]
        // ni potrbno tako že pride, lahko bi pa motilo v bodoče .sort((a, b) => a.zap - b.zap)
        .map(el => ({
          znak: el.znak,
          odg: el.izpis,
          barva: el.barva,
          font: el.font,
        }));
    },
  },
  mounted() {
    this.details = this.getDetails
    this.showLegenda();
  }
};
</script>